import {
  Component,
  ElementRef,
  AfterViewInit,
  Renderer2,
  Input,
  Inject,
  ViewChild,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { CommonModule, DOCUMENT } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { Router, RouterModule } from '@angular/router';

import { Colors, Sizes } from '../../../shared/enums/shared.enums';
import { CaasBodytextService } from '../../../services/caas-bodytext.service';

@Component({
  selector: 'hdi-tooltip',
  standalone: true,
  imports: [CommonModule, IconComponent, RouterModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  animations: [
    trigger('tooltipAnimation', [
      state(
        'void',
        style({
          opacity: 0,
        })
      ),
      state(
        '*',
        style({
          opacity: 1,
        })
      ),
      transition('void => *', [animate('300ms ease-in')]),
      transition('* => void', [animate('300ms ease-out')]),
    ]),
  ],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class TooltipComponent implements AfterViewInit, OnDestroy {
  @Input() type: 'click' | 'hover' = 'click';
  @Output() closeTooltipEvent = new EventEmitter<void>();
  @ViewChild('tooltipContainer') tooltipContainer!: ElementRef<HTMLElement>;
  private _tooltip: { id: string; description: string } = {
    id: '',
    description: '',
  };
  @Input()
  set tooltip(value: { id: string; description: string }) {
    if (value) {
      this._tooltip = {
        ...value,
        description: this.caasBodytextService.extractTextEditorContent(
          value.description,
          'bodytext-link--white'
        ),
      };
    }
  }

  get tooltip(): { id: string; description: string } {
    return this._tooltip;
  }
  parentElement!: ElementRef<HTMLElement>;
  routerLinkEventListener?: EventListener;

  Sizes = Sizes;
  Colors = Colors;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private el: ElementRef,
    private router: Router,
    private caasBodytextService: CaasBodytextService
  ) {
    this.tooltip = {
      id: '',
      description: '',
    };
  }

  ngAfterViewInit(): void {
    this.parentElement = this.el.nativeElement.parentElement;
    this.renderer.setStyle(this.parentElement, 'position', 'relative');
    const routerLinkElement =
      this.tooltipContainer.nativeElement.querySelector('[routerLink]');
    if (routerLinkElement) {
      this.routerLinkEventListener = (event: Event) => {
        event.preventDefault();
        this.router.navigateByUrl(
          routerLinkElement.getAttribute('routerLink') || ''
        );
      };
      routerLinkElement.addEventListener('click', this.routerLinkEventListener);
    }
    this.tooltip.description =
      this.caasBodytextService.extractTextEditorContent(
        this.tooltip.description
      );
  }

  closeTooltip(event: Event) {
    event.stopPropagation();
    this.closeTooltipEvent.emit();
  }

  ngOnDestroy(): void {
    if (this.routerLinkEventListener) {
      this.tooltipContainer.nativeElement.removeEventListener(
        'click',
        this.routerLinkEventListener
      );
    }
  }
}
